'use client';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import { AllAppliances } from './AllAppliances';
import PropTypes from 'prop-types';

const AppliancesPage = ({ userIsAdmin }) => {
  return (
    <TableViewerLayout
      tableTitle='All Appliances'
      tableSlot={<AllAppliances userIsAdmin={userIsAdmin} />}
    />
  );
};

AppliancesPage.propTypes = {
  userIsAdmin: PropTypes.bool.isRequired,
};

export default AppliancesPage;
